<agpr-dialog-container
    [id]="id"
    class="agpr-sessionExpired-dialogContainer"
    heading="Core.login.sessionExpiredHeader"
    (close)="closeDialog()"
    [contentPadding]="false"
    [agprLoading]="loading"
    [agprGlobalLoading]="true"
>
    <agpr-scroll-panel class="agpr-sessionExpired-content">
        <div>{{ 'Core.login.sessionExpiredMessage' | localize }}</div>
    </agpr-scroll-panel>
    <ng-template #footerLeft>
        <agpr-button
            [id]="id + '-cancelBtn'"
            label="Core.login.sessionExpiredButtonCancel"
            (click)="close()"
            [style]="buttonTypesEnum.secondary"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [id]="id + '-submitBtn'"
            label="Core.login.sessionExpiredButton"
            (click)="accept()"
            [style]="buttonTypesEnum.primary"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
